import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { Grid, FormControl, InputLabel, Select, Input, MenuItem, Button } from '@material-ui/core';

export class SearchBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchText: this.props.searchText || ''
    }
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <form key='form' autoComplete='off' className={css(Styles.form)}>
          <div>
            <Grid container >
              <Grid item xs={6} sm={4}>
                <FormControl key='searchKeywords' margin='normal' fullWidth >
                  <Input className={css(Styles.searchInput)} type='text' name='search'
                    placeholder='Type keywords' value={this.state.searchText} onChange={this.onSearchKeywordsChange.bind(this)} />
                </FormControl>
              </Grid>
              <Grid className={css(Styles.rightGridPadding)} item xs={6} sm={2}>
                <Button
                  className = {css(Styles.button, Styles.emailSearchButton)}
                  variant='contained' color='primary' onClick={this.onSearch.bind(this)}>
                  Search
                </Button>
              </Grid>
              <Grid className={css(Styles.rightGridPadding)} item xs={6} sm={2}>
                {this.props.onList &&
                  <Button
                    className = {css(Styles.button, Styles.emailSearchButton)}
                    variant='contained' color='primary' onClick={this.props.onList.bind(this)}>
                    List recent
                  </Button>
                }
              </Grid>
            </Grid>
          </div>
        </form>
      </div>
    )
  }

  onSearchKeywordsChange = (event) => {
    const target = event.target;
    const value = target.value;
    this.setState({
      searchText: value
    })
  }

  onSearch() {
    this.setState({
      searchText: this.state.searchText
    })
    this.props.onSearch(this.state.searchText)
  }
}


const Styles = StyleSheet.create({
  container: {
    // top: AppTheme.toolbarHeight,
    minHeight: AppTheme.toolbarHeight * 2 / 3,
    display: 'flex',
    justifyContent: 'center',
    // backgroundColor: 'white',
    width: '100%',
    marginBottom: 16,
    maxWidth: AppTheme.viewPort,
  },
  searchInput: {
    minWidth: 150,
    paddingTop: 2,
    paddingBottom: 2
  },
  button: {
    boxShadow: 'none',
    // marginLeft : 10,
    minWidth: 150
  },
  emailSearchButton: {
    marginTop: 16,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // padding: AppTheme.pagePadding,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    },
    maxWidth: AppTheme.viewPort,
    backgroundColor: 'white',
    paddingTop: 0,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    width: '100%',
    borderRadius: 8
  },
  leftGridPadding: {
    paddingRight: 10
  },
  rightGridPadding: {
    paddingLeft: 10
  }
})


// WEBPACK FOOTER //
// ./src/common/components/SearchBar.js